module.exports = __webpack_public_path__ + "img/cover.35aa19a7.png";